import { render, staticRenderFns } from "./attachment-mobile-viewer.vue?vue&type=template&id=37ac6cb0"
import script from "./attachment-mobile-viewer.vue?vue&type=script&lang=js"
export * from "./attachment-mobile-viewer.vue?vue&type=script&lang=js"
import style0 from "./attachment-mobile-viewer.vue?vue&type=style&index=0&id=37ac6cb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports